"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var BrandAccount_1, LevelInfo_1, Campaign_1, AdSet_1, Ad_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Ad = exports.AdSet = exports.Campaign = exports.LevelInfo = exports.BrandAccount = exports.Entity = exports.BaseShape = void 0;
const QuoraAccount_1 = require("./QuoraAccount");
const dc_1 = require("lincd-dcmi/lib/ontologies/dc");
const rdf_1 = require("lincd-rdf/lib/ontologies/rdf");
const ImageObject_1 = require("lincd-schema/lib/shapes/ImageObject");
const VideoObject_1 = require("lincd-schema/lib/shapes/VideoObject");
const Server_1 = require("lincd-server-utils/lib/utils/Server");
const sioc_1 = require("lincd-sioc/lib/ontologies/sioc");
const xsd_1 = require("lincd-xsd/lib/ontologies/xsd");
const NodeValuesSet_1 = require("lincd/lib/collections/NodeValuesSet");
const ShapeSet_1 = require("lincd/lib/collections/ShapeSet");
const Observation_1 = require("lincd-schema/lib/shapes/Observation");
const models_1 = require("lincd/lib/models");
const Shape_1 = require("lincd/lib/shapes/Shape");
const ShapeDecorators_1 = require("lincd/lib/utils/ShapeDecorators");
const nanoid_1 = require("nanoid");
const titan_ads_1 = require("../ontologies/titan-ads");
const package_1 = require("../package");
const utils_1 = require("../utils");
const Answer_1 = require("./Answer");
const Audience_1 = require("./Audience");
const Delivering_1 = require("./Delivering");
const LandingPage_1 = require("./LandingPage");
const Location_1 = require("./Location");
const Question_1 = require("./Question");
const Topic_1 = require("./Topic");
const Observation_2 = require("lincd-schema/lib/shapes/Observation");
const Boolean_1 = require("lincd-xsd/lib/shapes/Boolean");
const XSDDate_1 = require("lincd-xsd/lib/shapes/XSDDate");
const Thing_1 = require("lincd-schema/lib/shapes/Thing");
const LinkedEmail_1 = require("lincd-server-utils/lib/utils/LinkedEmail");
const ALPHABET = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
const generateID = (0, nanoid_1.customAlphabet)(ALPHABET, 8);
let BaseShape = class BaseShape extends Shape_1.Shape {
    constructor(...args) {
        super(...args);
    }
    get quoraId() {
        return +this.getValue(sioc_1.sioc.id);
    }
    set quoraId(val) {
        this.overwrite(sioc_1.sioc.id, new models_1.Literal(`${val}`, xsd_1.xsd.integer));
    }
    get automations() {
        return Thing_1.Thing.getSetOf(this.getAll(titan_ads_1.titanAds.automation));
    }
    get lastModified() {
        return XSDDate_1.XSDDate.toNativeDate(this.getOne(titan_ads_1.titanAds.lastModified));
    }
    set lastModified(val) {
        this.overwrite(titan_ads_1.titanAds.lastModified, XSDDate_1.XSDDate.fromNativeDate(val).node);
    }
    setAutomations(...automations) {
        // this.moverwrite(titanAds.automation,new NodeSet(automations));
        this.unsetAll(titan_ads_1.titanAds.automation);
        automations.forEach(automation => {
            this.set(titan_ads_1.titanAds.automation, automation);
        });
    }
    /**
     * Returns the name for this adset as it is used in Quora.
     * Since the name is already used in so many places (and it's acting more like an ID)
     * we're introducing a new property just for the quora name
     */
    get name() {
        return this.getValue(dc_1.dcelems.title);
    }
    set name(val) {
        this.overwrite(dc_1.dcelems.title, new models_1.Literal(val));
    }
    get launchDate() {
        return this.getValue(titan_ads_1.titanAds.launchDate);
    }
    set launchDate(val) {
        this.overwrite(titan_ads_1.titanAds.launchDate, new models_1.Literal(val));
    }
    setLaunchDate() {
        //MM/DD/YY
        const date = new Date();
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear().toString().slice(2);
        this.launchDate = `${month}/${day}/${year}`;
    }
    get hasBeenUnpaused() {
        return this.getValue(titan_ads_1.titanAds.hasBeenUnpaused) === 'true';
    }
    set hasBeenUnpaused(val) {
        this.overwrite(titan_ads_1.titanAds.hasBeenUnpaused, new models_1.Literal(`${val}`));
    }
    /**
     * Returns the name of the current shape.
     *
     * In the case of using ``brandAccount.name``, this will return the LONG
     * name.  Use ``brandAccount.shortName`` to retrieve the SHORT name
     */
    get identifier() {
        // Fix for edge case - imported ad account
        // if (this.has(rdf.type, titanAds.AdSet)) {
        //   if (
        //     !this.namedNode.isTemporaryNode &&
        //     (this as unknown as AdSet).campaign?.account?.hasValue(
        //       dcelems.identifier,
        //       'Test',
        //     )
        //   ) {
        //     return this.uri.split('/').pop();
        //   }
        // }
        return this.getValue(dc_1.dcelems.identifier);
    }
    set identifier(val) {
        this.overwrite(dc_1.dcelems.identifier, new models_1.Literal(val));
    }
};
exports.BaseShape = BaseShape;
/**
 * indicates that instances of this shape need to have this rdf.type
 */
BaseShape.targetClass = titan_ads_1.titanAds.BaseShape;
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: sioc_1.sioc.id,
        maxCount: 1,
        dataType: xsd_1.xsd.integer,
    }),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], BaseShape.prototype, "quoraId", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: titan_ads_1.titanAds.lastModified,
    }),
    __metadata("design:type", Date),
    __metadata("design:paramtypes", [Date])
], BaseShape.prototype, "lastModified", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: dc_1.dcelems.title,
        required: true,
        maxCount: 1,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], BaseShape.prototype, "name", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: titan_ads_1.titanAds.launchDate,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], BaseShape.prototype, "launchDate", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: titan_ads_1.titanAds.hasBeenUnpaused,
    }),
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [Boolean])
], BaseShape.prototype, "hasBeenUnpaused", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: dc_1.dcelems.identifier,
        required: true,
        maxCount: 1,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], BaseShape.prototype, "identifier", null);
exports.BaseShape = BaseShape = __decorate([
    package_1.linkedShape,
    __metadata("design:paramtypes", [Object])
], BaseShape);
class Entity {
}
exports.Entity = Entity;
let BrandAccount = BrandAccount_1 = class BrandAccount extends BaseShape {
    get quoraId() {
        return this.quoraAccount.id;
    }
    /**
     *
     */
    // constructor() {
    //   const URI =
    //     process.env.DATA_ROOT + '/' + BrandAccount.getNumLocalInstances();
    //   const node = NamedNode.getOrCreate(URI, true);
    //   super(node);
    // }
    // Remove all campaigns, adsets, and ads of an account
    removeAllChildren() {
        this.campaigns.forEach((c) => {
            c.adSets.forEach((a) => {
                a.ads.forEach((a) => a.remove());
                a.remove();
            });
            c.remove();
        });
    }
    unassignQuoraAccount() {
        this.unset(titan_ads_1.titanAds.quoraAccount, this.quoraAccount.node);
    }
    static loadAll() {
        return Server_1.Server.call(package_1.packageName, 'loadAll', BrandAccount_1.shape.namedNode);
    }
    async delete(isServerCall = false) {
        if (!isServerCall) {
            Server_1.Server.call(package_1.packageName, 'deleteAccount', this);
            // .then(
            //   this.removeAllChildren,
            // );
            this.remove();
        }
        else {
            // this.removeAllChildren();
            this.remove();
        }
    }
    get campaigns() {
        return Campaign.getSetOf(this.getAllInverse(titan_ads_1.titanAds.brandAccount));
    }
    get quoraAccount() {
        return this.getOneAs(titan_ads_1.titanAds.quoraAccount, QuoraAccount_1.QuoraAccount);
    }
    set quoraAccount(val) {
        this.overwrite(titan_ads_1.titanAds.quoraAccount, val.node);
    }
    get shortName() {
        return this.getValue(dc_1.dcelems.identifier);
    }
    set shortName(val) {
        this.overwrite(dc_1.dcelems.identifier, new models_1.Literal(val));
    }
    get offer() {
        return this.getValue(titan_ads_1.titanAds.offer);
    }
    set offer(val) {
        this.overwrite(titan_ads_1.titanAds.offer, new models_1.Literal(val));
    }
    //
    // /*
    //  * These properties were moved from shape Account
    //  * from titan-interactive-api/modules/ads/src/shapes/Account
    //  */
    //
    // @literalProperty({
    //   name: 'clicks',
    //   path: titanAds.clicks,
    //   dataType: xsd.integer,
    //   required: true,
    //   maxCount: 1,
    // })
    // get clicks(): number {
    //   return Number.parseInt(this.getValue(titanAds.clicks));
    // }
    //
    // set clicks(val: number) {
    //   this.overwrite(titanAds.clicks, new Literal(`${val}`, xsd.integer));
    // }
    //
    // @literalProperty({
    //   path: titanAds.cpc,
    //   dataType: xsd.integer,
    //   required: true,
    //   maxCount: 1,
    // })
    // get cpc(): number {
    //   return Number.parseInt(this.getValue(titanAds.cpc));
    // }
    //
    // set cpc(val: number) {
    //   this.overwrite(titanAds.cpc, new Literal(`${val}`, xsd.integer));
    // }
    //
    // @literalProperty({
    //   path: titanAds.ctr,
    //   dataType: xsd.decimal,
    //   required: true,
    //   maxCount: 1,
    // })
    // get ctr(): number {
    //   return Number.parseFloat(this.getValue(titanAds.ctr));
    // }
    //
    // set ctr(val: number) {
    //   this.overwrite(titanAds.ctr, new Literal(`${val}`, xsd.decimal));
    // }
    //
    // @literalProperty({
    //   path: titanAds.accountCurrency,
    //   dataType: xsd.string,
    //   maxCount: 1,
    // })
    // get currency(): string {
    //   return this.getValue(titanAds.accountCurrency);
    // }
    //
    // set currency(val: string) {
    //   this.overwrite(titanAds.accountCurrency, new Literal(val));
    // }
    //
    // @literalProperty({
    //   path: dcelems.identifier,
    //   dataType: xsd.integer,
    //   required: true,
    //   maxCount: 1,
    // })
    // get id(): number {
    //   return Number.parseInt(this.getValue(dcelems.identifier));
    // }
    //
    // set id(val: number) {
    //   this.overwrite(dcelems.identifier, new Literal(`${val}`, xsd.integer));
    // }
    //
    // @literalProperty({
    //   path: titanAds.impressions,
    //   dataType: xsd.integer,
    //   maxCount: 1,
    // })
    // get impressions(): number {
    //   return Number.parseInt(this.getValue(titanAds.impressions));
    // }
    //
    // set impressions(val: number) {
    //   this.overwrite(titanAds.impressions, new Literal(`${val}`, xsd.integer));
    // }
    get name() {
        return this.getValue(dc_1.dcelems.title);
    }
    set name(val) {
        this.overwrite(dc_1.dcelems.title, new models_1.Literal(val));
    }
};
exports.BrandAccount = BrandAccount;
BrandAccount.targetClass = titan_ads_1.titanAds.BrandAccount;
__decorate([
    (0, ShapeDecorators_1.objectProperty)({
        path: titan_ads_1.titanAds.hasCampaigns,
        // required: true,
    }),
    __metadata("design:type", ShapeSet_1.ShapeSet),
    __metadata("design:paramtypes", [])
], BrandAccount.prototype, "campaigns", null);
__decorate([
    (0, ShapeDecorators_1.objectProperty)({
        path: titan_ads_1.titanAds.quoraAccount,
    }),
    __metadata("design:type", QuoraAccount_1.QuoraAccount),
    __metadata("design:paramtypes", [QuoraAccount_1.QuoraAccount])
], BrandAccount.prototype, "quoraAccount", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: dc_1.dcelems.identifier,
        required: true,
        maxCount: 1,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], BrandAccount.prototype, "shortName", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: titan_ads_1.titanAds.offer,
        maxCount: 1,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], BrandAccount.prototype, "offer", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: dc_1.dcelems.title,
        dataType: xsd_1.xsd.string,
        required: true,
        maxCount: 1,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], BrandAccount.prototype, "name", null);
exports.BrandAccount = BrandAccount = BrandAccount_1 = __decorate([
    package_1.linkedShape
], BrandAccount);
// Ads, AdSets, and Campaigns are referred to as 'Levels' in
// the Quora docs, so that's the terminology being used here
// TODO: Redo the properties here - work from Account -> Ad
let LevelInfo = LevelInfo_1 = class LevelInfo extends BaseShape {
    sendTaskEmail({ subject, message }) {
        LinkedEmail_1.LinkedEmail.send({
            to: [{ email_address: { address: process.env.CLIENT_TEAM_EMAIL, name: 'Titan' } }],
            subject,
            htmlbody: message,
        });
    }
    get brandAccount() {
        return this.getOneAs(titan_ads_1.titanAds.brandAccount, BrandAccount);
    }
    set brandAccount(val) {
        this.overwrite(titan_ads_1.titanAds.brandAccount, val.namedNode);
    }
    //Since some ads are retrieved from the quora API
    //we cannot just use brandAccount (which is what we will use when we create the entity through our dashboard),
    // instead we will also couple all entities to their quoraAccount
    //so some ads, that are not created through the dashboard but DO exist in quora, will only have a quoraAccount
    get quoraAccount() {
        return this.getOneAs(titan_ads_1.titanAds.quoraAccount, QuoraAccount_1.QuoraAccount);
    }
    set quoraAccount(val) {
        this.overwrite(titan_ads_1.titanAds.quoraAccount, val.node);
    }
    get isActive() {
        //overwritten by ad/adset/campaign
        return false;
    }
    get bidAmount() {
        return this.hasProperty(titan_ads_1.titanAds.bidAmount) ? parseFloat(this.getValue(titan_ads_1.titanAds.bidAmount)) : undefined;
    }
    set bidAmount(val) {
        this.overwrite(titan_ads_1.titanAds.bidAmount, new models_1.Literal(`${val}`, xsd_1.xsd.integer));
    }
    get dailyClicks() {
        return this.hasProperty(titan_ads_1.titanAds.dailyClicks) ? (Number.parseInt(this.getValue(titan_ads_1.titanAds.dailyClicks)) || 0) : undefined;
    }
    set dailyClicks(val) {
        this.overwrite(titan_ads_1.titanAds.dailyClicks, new models_1.Literal(`${val}`, xsd_1.xsd.integer));
    }
    get clicksSinceLastSale() {
        return this.hasProperty(titan_ads_1.titanAds.clicksSinceLastSale) ? Number.parseInt(this.getValue(titan_ads_1.titanAds.clicksSinceLastSale)) : undefined;
    }
    set clicksSinceLastSale(val) {
        this.overwrite(titan_ads_1.titanAds.clicksSinceLastSale, new models_1.Literal(`${val}`, xsd_1.xsd.integer));
    }
    get identifier() {
        return this.getValue(dc_1.dcelems.identifier);
    }
    set identifier(val) {
        this.overwrite(dc_1.dcelems.identifier, new models_1.Literal(val));
    }
    get cpc() {
        return this.hasProperty(titan_ads_1.titanAds.cpc) ? Number.parseInt(this.getValue(titan_ads_1.titanAds.cpc)) : undefined;
    }
    set cpc(val) {
        this.overwrite(titan_ads_1.titanAds.cpc, new models_1.Literal(`${val || 0}`, xsd_1.xsd.integer));
    }
    get ctr() {
        return this.hasProperty(titan_ads_1.titanAds.ctr) ? Number.parseFloat(this.getValue(titan_ads_1.titanAds.ctr)) : undefined;
    }
    set ctr(val) {
        this.overwrite(titan_ads_1.titanAds.ctr, new models_1.Literal(`${val || 0}`, xsd_1.xsd.decimal));
    }
    static generateURI(id) {
        return `${LevelInfo_1.URI}level/${id}`;
    }
    get dailyRevenue() {
        return NaN;
    }
    get dailyAveragePayout() {
        return this.dailyRevenue / this.dailySales;
    }
    // @literalProperty({
    //     path: dcelems.identifier,
    //     dataType: xsd.integer,
    //     required: true,
    //     maxCount: 1,
    // })
    // get id(): number {
    //     return Number.parseInt(this.getValue(dcelems.identifier));
    // }
    // set id(val: number) {
    //     this.overwrite(dcelems.identifier, new Literal(`${val}`, xsd.integer));
    // }
    get id() {
        return this.getValue(sioc_1.sioc.id);
    }
    set id(val) {
        if (typeof val === 'number') {
            val = val.toString();
        }
        this.overwrite(sioc_1.sioc.id, new models_1.Literal(val));
    }
    get dailyImpressions() {
        return this.hasProperty(titan_ads_1.titanAds.dailyImpressions) ? (Number.parseInt(this.getValue(titan_ads_1.titanAds.dailyImpressions)) || 0) : undefined;
    }
    set dailyImpressions(val) {
        this.overwrite(titan_ads_1.titanAds.dailyImpressions, new models_1.Literal(`${val}`, xsd_1.xsd.integer));
    }
    get name() {
        return this.getValue(dc_1.dcelems.title);
    }
    set name(val) {
        if (val.length > 255) {
            throw new Error('Name is too long. Max length is 255 characters');
        }
        this.overwrite(dc_1.dcelems.title, new models_1.Literal(val));
    }
    get dailySales() {
        return this.hasProperty(titan_ads_1.titanAds.dailySales) ? (Number.parseInt(this.getValue(titan_ads_1.titanAds.dailySales)) || 0) : undefined;
    }
    set dailySales(val) {
        this.overwrite(titan_ads_1.titanAds.dailySales, new models_1.Literal(`${val}`, xsd_1.xsd.integer));
    }
    get lastReductionDate() {
        return XSDDate_1.XSDDate.toNativeDate(this.getOne(titan_ads_1.titanAds.lastReductionDate));
    }
    set lastReductionDate(val) {
        this.overwrite(titan_ads_1.titanAds.lastReductionDate, XSDDate_1.XSDDate.fromNativeDate(val).node);
    }
    get dailyLead() {
        return this.hasProperty(titan_ads_1.titanAds.dailyLead) ? (Number.parseInt(this.getValue(titan_ads_1.titanAds.dailyLead)) || 0) : undefined;
    }
    set dailyLead(val) {
        this.overwrite(titan_ads_1.titanAds.dailyLead, new models_1.Literal(`${val}`, xsd_1.xsd.integer));
    }
    get dailySearch() {
        return this.hasProperty(titan_ads_1.titanAds.dailySearch) ? (Number.parseInt(this.getValue(titan_ads_1.titanAds.dailySearch)) || 0) : undefined;
    }
    set dailySearch(val) {
        this.overwrite(titan_ads_1.titanAds.dailySearch, new models_1.Literal(`${val}`, xsd_1.xsd.integer));
    }
    get totalSales() {
        return this.hasProperty(titan_ads_1.titanAds.totalSales) ? Number.parseInt(this.getValue(titan_ads_1.titanAds.totalSales)) : undefined;
    }
    set totalSales(val) {
        this.overwrite(titan_ads_1.titanAds.totalSales, new models_1.Literal(`${val}`, xsd_1.xsd.integer));
    }
    get totalLead() {
        return this.hasProperty(titan_ads_1.titanAds.totalLead) ? Number.parseInt(this.getValue(titan_ads_1.titanAds.totalLead)) : undefined;
    }
    set totalLead(val) {
        this.overwrite(titan_ads_1.titanAds.totalLead, new models_1.Literal(`${val}`, xsd_1.xsd.integer));
    }
    get totalSearch() {
        return this.hasProperty(titan_ads_1.titanAds.totalSearch) ? Number.parseInt(this.getValue(titan_ads_1.titanAds.totalSearch)) : undefined;
    }
    set totalSearch(val) {
        this.overwrite(titan_ads_1.titanAds.totalSearch, new models_1.Literal(`${val}`, xsd_1.xsd.integer));
    }
    get dailySpend() {
        return this.hasProperty(titan_ads_1.titanAds.dailySpend) ? (Number.parseFloat(this.getValue(titan_ads_1.titanAds.dailySpend)) || 0) : undefined;
    }
    set dailySpend(val) {
        this.overwrite(titan_ads_1.titanAds.dailySpend, new models_1.Literal(`${val}`, xsd_1.xsd.decimal));
    }
    get status() {
        return this.getValue(titan_ads_1.titanAds.status);
    }
    set status(val) {
        this.overwrite(titan_ads_1.titanAds.status, new models_1.Literal(val));
    }
    get statusUserFriendly() {
        let s = this.status || '';
        //rename running to 'on'
        if (s === 'RUNNING')
            s = 'on';
        //capitalise first letter
        return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
    }
    turnOn() {
        return Server_1.Server.call(package_1.packageName, 'unpauseEntity', this);
    }
    turnOff() {
        return Server_1.Server.call(package_1.packageName, 'pauseEntity', this);
    }
};
exports.LevelInfo = LevelInfo;
LevelInfo.URI = `http://data.titan-interactive.com/`;
LevelInfo.targetClass = titan_ads_1.titanAds.LevelInfo;
__decorate([
    (0, ShapeDecorators_1.objectProperty)({
        path: titan_ads_1.titanAds.brandAccount,
        shape: BrandAccount,
        maxCount: 1,
    }),
    __metadata("design:type", BrandAccount),
    __metadata("design:paramtypes", [BrandAccount])
], LevelInfo.prototype, "brandAccount", null);
__decorate([
    (0, ShapeDecorators_1.objectProperty)({
        path: titan_ads_1.titanAds.quoraAccount,
    }),
    __metadata("design:type", QuoraAccount_1.QuoraAccount),
    __metadata("design:paramtypes", [QuoraAccount_1.QuoraAccount])
], LevelInfo.prototype, "quoraAccount", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: titan_ads_1.titanAds.bidAmount,
        dataType: xsd_1.xsd.integer,
        required: true,
        maxCount: 1,
    }),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], LevelInfo.prototype, "bidAmount", null);
__decorate([
    (0, Observation_1.observe)({
        range: 'sum',
    }),
    (0, ShapeDecorators_1.literalProperty)({
        name: 'dailyClicks',
        path: titan_ads_1.titanAds.dailyClicks,
        dataType: xsd_1.xsd.integer,
        required: true,
        maxCount: 1,
    }),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], LevelInfo.prototype, "dailyClicks", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        name: 'clicksSinceLastSale',
        path: titan_ads_1.titanAds.clicksSinceLastSale,
        dataType: xsd_1.xsd.integer,
        required: true,
        maxCount: 1,
    }),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], LevelInfo.prototype, "clicksSinceLastSale", null);
__decorate([
    (0, ShapeDecorators_1.objectProperty)({
        path: dc_1.dcelems.identifier,
        required: true,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], LevelInfo.prototype, "identifier", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: titan_ads_1.titanAds.cpc,
        dataType: xsd_1.xsd.integer,
        required: true,
        maxCount: 1,
    }),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], LevelInfo.prototype, "cpc", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: titan_ads_1.titanAds.ctr,
        dataType: xsd_1.xsd.decimal,
        required: true,
        maxCount: 1,
    }),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], LevelInfo.prototype, "ctr", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: sioc_1.sioc.id,
        required: true,
        maxCount: 1,
    })
    /**
     * Returns the id as it is in Quora.
     * Same as quoraId
     */
    ,
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], LevelInfo.prototype, "id", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: titan_ads_1.titanAds.dailyImpressions,
        dataType: xsd_1.xsd.integer,
        maxCount: 1,
    }),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], LevelInfo.prototype, "dailyImpressions", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: dc_1.dcelems.title,
        dataType: xsd_1.xsd.string,
        required: true,
        maxCount: 1,
        maxLength: 255,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], LevelInfo.prototype, "name", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: titan_ads_1.titanAds.dailySales,
        dataType: xsd_1.xsd.integer,
        maxCount: 1,
    }),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], LevelInfo.prototype, "dailySales", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: titan_ads_1.titanAds.lastReductionDate,
        dataType: xsd_1.xsd.string,
        required: true,
        maxCount: 1,
    }),
    __metadata("design:type", Date),
    __metadata("design:paramtypes", [Date])
], LevelInfo.prototype, "lastReductionDate", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: titan_ads_1.titanAds.dailyLead,
        dataType: xsd_1.xsd.integer,
        maxCount: 1,
    }),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], LevelInfo.prototype, "dailyLead", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: titan_ads_1.titanAds.dailySearch,
        dataType: xsd_1.xsd.integer,
        maxCount: 1,
    }),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], LevelInfo.prototype, "dailySearch", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: titan_ads_1.titanAds.totalSales,
        dataType: xsd_1.xsd.integer,
        maxCount: 1,
    }),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], LevelInfo.prototype, "totalSales", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: titan_ads_1.titanAds.totalLead,
        dataType: xsd_1.xsd.integer,
        maxCount: 1,
    }),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], LevelInfo.prototype, "totalLead", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: titan_ads_1.titanAds.totalSearch,
        dataType: xsd_1.xsd.integer,
        maxCount: 1,
    }),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], LevelInfo.prototype, "totalSearch", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: titan_ads_1.titanAds.dailySpend,
        dataType: xsd_1.xsd.decimal,
        maxCount: 1,
    }),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], LevelInfo.prototype, "dailySpend", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: titan_ads_1.titanAds.status,
        dataType: xsd_1.xsd.string,
        maxCount: 1,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], LevelInfo.prototype, "status", null);
exports.LevelInfo = LevelInfo = LevelInfo_1 = __decorate([
    package_1.linkedShape
], LevelInfo);
let Campaign = Campaign_1 = class Campaign extends LevelInfo {
    /**
     * @param accountOrNode The account to which this campaign will belong
     */
    constructor(accountOrNode, isTemplate = false, templateName) {
        if (isTemplate) {
            //for templates, we just create a temporary node, and the URI will be set later in the backend on createTemplate()
            super();
            this.isTemplate = true;
            // this.account = accountOrNode as BrandAccount;
        }
        else if (accountOrNode instanceof BrandAccount) {
            let campaignIdentifier = Campaign_1.generateNewIdentifier(accountOrNode);
            let campaignUri = accountOrNode.uri + '/' + campaignIdentifier.split('-').pop();
            //generateNewName now is updated to fix a bug where the same URI was used for different sets of overlapping data,
            //so the same URI should in theory not be used anymore when creating a new Campaign
            let extraCounter = 0;
            while (models_1.NamedNode.getNamedNode(campaignUri)) {
                campaignIdentifier = Campaign_1.generateNewIdentifier(accountOrNode, ++extraCounter);
                campaignUri =
                    accountOrNode.uri + '/' + campaignIdentifier.split('-').pop();
            }
            const campaignNode = models_1.NamedNode.getOrCreate(campaignUri, true);
            campaignNode.overwrite(rdf_1.rdf.type, titan_ads_1.titanAds.Campaign);
            super(campaignNode);
            this.account = accountOrNode;
            this.identifier = campaignIdentifier;
        }
        else {
            super(accountOrNode);
        }
    }
    get isActive() {
        return this.status === 'RUNNING';
    }
    get dailyRevenue() {
        return this.adSets.map(a => a.dailyRevenue || 0).reduce((a, b) => a + b, 0);
    }
    get totalRevenue() {
        return this.adSets.map(a => a.totalRevenue || 0).reduce((a, b) => a + b, 0);
    }
    get dailySales() {
        return this.adSets.map(a => a.dailySales || 0).reduce((a, b) => a + b, 0);
    }
    get totalSales() {
        return this.adSets.map(a => a.totalSales || 0).reduce((a, b) => a + b, 0);
    }
    remove() {
        this.adSets.forEach((adSet) => adSet.remove());
        super.remove();
    }
    setName(adSetForNaming, limit = 255) {
        // Test-C005,
        // ad? KEEP ON (now hardcoded)
        // adset [Device+Browser]
        // adset [Placement]
        // adset [Offer]
        // adset [GEO]
        // campaign [Vertical]
        // campaign [Objective]
        // campaign [Conversion Event]
        // campaign [Creation Date - MM/DD/YY]
        const adsetProps = this.getAdsetGroupProps(adSetForNaming);
        const optionalProps = [
            adsetProps.deviceAndBrowser,
            adsetProps.placement,
            this.offer,
            adsetProps.geo,
            this.vertical,
            this.conversionObjective,
            this.conversionEvent,
        ];
        if (!this.identifier || !this.launchDate) {
            throw new Error('Campaign name and launch date must be set before calling setName()');
        }
        this.name = (0, utils_1.generateName)(this.identifier + ' - UNTESTED', optionalProps, this.launchDate, limit);
        return this.name;
    }
    setPropertiesFromInput(input) {
        input['campaign__Campaign Geo'] &&
            (this.geo = input['campaign__Campaign Geo']);
        input['campaign__Campaign Offer'] &&
            (this.offer = input['campaign__Campaign Offer']);
        input['campaign__Vertical'] &&
            (this.vertical = input['campaign__Vertical']);
    }
    /**
     * @see AdSet.getAdSetProps
     * @param groupKey
     */
    getAdsetGroupProps(adSetForNaming) {
        //see also AdSet.getCampaignGroupKey()
        const adSet = adSetForNaming || this.adSets.first();
        return {
            deviceAndBrowser: adSet === null || adSet === void 0 ? void 0 : adSet.deviceAndBrowser,
            placement: adSet === null || adSet === void 0 ? void 0 : adSet.placement,
            offer: adSet === null || adSet === void 0 ? void 0 : adSet.offer,
            geo: adSet === null || adSet === void 0 ? void 0 : adSet.geo,
            vertical: this.vertical,
            conversionObjective: this.conversionObjective,
            conversionEvent: this.conversionEvent,
        };
        // const [deviceAndBrowser, placement, offer, geo, vertical, conversionObjective, conversionEvent] = groupKey.split('-');
        // return {deviceAndBrowser, placement, offer, geo, vertical, conversionObjective, conversionEvent};
    }
    static generateNewIdentifier(account, extraCounter = 0) {
        // const numOfPreviousCampaigns =
        //   account.campaigns?.filter((campaign) => !campaign.isTemplate)?.size || 0;
        // const newId = padId(numOfPreviousCampaigns + 1);
        let maxNumber = Math.max(...account.campaigns
            .filter((campaign) => !campaign.isTemplate)
            .map((c) => { var _a; return parseInt((c.identifier || ((_a = c.name) === null || _a === void 0 ? void 0 : _a.split(' - ')[0]) || '').split('-').pop().replace('C', '')); }));
        if (!maxNumber || isNaN(maxNumber) || maxNumber === -Infinity) {
            maxNumber = 0;
        }
        if (extraCounter) {
            maxNumber += extraCounter;
        }
        const newId = (0, utils_1.zeroPad)(maxNumber + 1);
        const campaignName = `${account.shortName}-C${newId}`;
        return campaignName;
    }
    static loadAll() {
        return Server_1.Server.call(package_1.packageName, 'loadAll', Campaign_1.shape.namedNode);
    }
    static loadAllTemplates() {
        return Server_1.Server.call(this, 'loadAllTemplates');
    }
    async delete() {
        this.remove();
        return Server_1.Server.call(this, 'delete');
    }
    async quoraCreate() {
        const res = await Server_1.Server.call(this, 'quoraCreate', this);
        return true;
    }
    get adSets() {
        return AdSet.getSetOf(this.getAllInverse(titan_ads_1.titanAds.campaign));
    }
    set adSets(val) {
        val.updateEach(titan_ads_1.titanAds.campaign, this.namedNode);
    }
    get fromTemplate() {
        return this.getOneAs(titan_ads_1.titanAds.fromTemplate, Campaign_1);
    }
    set fromTemplate(val) {
        this.overwrite(titan_ads_1.titanAds.fromTemplate, val.node);
    }
    // A Campaign MUST belong to an Account!
    get account() {
        return this.getOneAs(titan_ads_1.titanAds.brandAccount, BrandAccount);
    }
    set account(val) {
        if (val && this.isTemplate) {
            throw new Error('You cannot assign an account to a template campaign.');
        }
        this.overwrite(titan_ads_1.titanAds.brandAccount, val.node);
    }
    get conversionObjective() {
        return this.getValue(titan_ads_1.titanAds.conversionObjective);
    }
    set conversionObjective(val) {
        this.overwrite(titan_ads_1.titanAds.conversionObjective, new models_1.Literal(val));
    }
    get conversionEvent() {
        return this.getValue(titan_ads_1.titanAds.conversionEvent);
    }
    set conversionEvent(val) {
        this.overwrite(titan_ads_1.titanAds.conversionEvent, new models_1.Literal(val !== null && val !== void 0 ? val : ''));
    }
    // The daily budget of a campaign, in USD, but represented in
    // cents (e.g. $100.00 -> 10000)
    // ^ as per https://stackoverflow.com/a/2876619/7808223
    get dailyBudget() {
        return this.hasProperty(titan_ads_1.titanAds.dailyBudget) ? (Number.parseFloat(this.getValue(titan_ads_1.titanAds.dailyBudget)) || 0) : undefined;
    }
    set dailyBudget(val) {
        this.overwrite(titan_ads_1.titanAds.dailyBudget, new models_1.Literal(`${val}`));
    }
    get delivering() {
        return this.getOneAs(titan_ads_1.titanAds.delivering, Delivering_1.Delivering);
    }
    set delivering(val) {
        this.overwrite(titan_ads_1.titanAds.delivering, val.node);
    }
    get geo() {
        return this.getValue(titan_ads_1.titanAds.geo);
    }
    set geo(val) {
        this.overwrite(titan_ads_1.titanAds.geo, new models_1.Literal(val));
    }
    get isQuickLaunched() {
        return this.getValue(titan_ads_1.titanAds.isQuickLaunched) === 'true';
    }
    set isQuickLaunched(val) {
        if (val)
            this.isTemplate = false;
        this.overwrite(titan_ads_1.titanAds.isQuickLaunched, new models_1.Literal(val.toString(), xsd_1.xsd.boolean));
    }
    get isTemplate() {
        return this.getValue(titan_ads_1.titanAds.isTemplate) === 'true';
    }
    set isTemplate(val) {
        // A template should be a standalone entity - it should not contain
        // any children or be connected to any parents
        // if (val) {
        //   this.account?.remove(); // Remove parent
        //   // TODO: Test this
        //   this.adSets.unsetEach(titanAds.campaign, this.namedNode); // Remove children
        // } else if (!this.account) {
        //   throw new Error('Please assign a brand account to this campaign.');
        // }
        this.overwrite(titan_ads_1.titanAds.isTemplate, new models_1.Literal(val.toString(), xsd_1.xsd.boolean));
    }
    // The lifetime budget of a campaign, in USD, but represented in
    // cents (e.g. $100.00 -> 10000)?
    // ^ as per https://stackoverflow.com/a/2876619/7808223
    get lifetimeBudget() {
        return this.hasProperty(titan_ads_1.titanAds.lifetimeBudget) ? Number.parseFloat(this.getValue(titan_ads_1.titanAds.lifetimeBudget)) : undefined;
    }
    set lifetimeBudget(val) {
        this.overwrite(titan_ads_1.titanAds.lifetimeBudget, new models_1.Literal(`${val}`));
    }
    get offer() {
        return this.getValue(titan_ads_1.titanAds.offer);
    }
    set offer(val) {
        this.overwrite(titan_ads_1.titanAds.offer, new models_1.Literal(val));
    }
    get vertical() {
        return this.getValue(titan_ads_1.titanAds.vertical);
    }
    set vertical(val) {
        this.overwrite(titan_ads_1.titanAds.vertical, new models_1.Literal(val));
    }
    //These properties come from Campaign.ts shape on /titan-interactive-api/modules/ads/src/shapes/
    static generateURI(id) {
        return `${LevelInfo.URI}campaign/${id}`;
    }
    get totalClicks() {
        return this.hasProperty(titan_ads_1.titanAds.totalClicks) ? Number.parseInt(this.getValue(titan_ads_1.titanAds.totalClicks)) : undefined;
    }
    set totalClicks(val) {
        this.overwrite(titan_ads_1.titanAds.totalClicks, new models_1.Literal(`${val}`, xsd_1.xsd.integer));
    }
    get totalImpressions() {
        return this.hasProperty(titan_ads_1.titanAds.totalImpressions) ? Number.parseInt(this.getValue(titan_ads_1.titanAds.totalImpressions)) : undefined;
    }
    set totalImpressions(val) {
        this.overwrite(titan_ads_1.titanAds.totalImpressions, new models_1.Literal(`${val}`, xsd_1.xsd.integer));
    }
    get totalSpend() {
        return this.hasProperty(titan_ads_1.titanAds.totalSpend) ? Number.parseInt(this.getValue(titan_ads_1.titanAds.totalSpend)) : undefined;
    }
    set totalSpend(val) {
        this.overwrite(titan_ads_1.titanAds.totalSpend, new models_1.Literal(`${val}`, xsd_1.xsd.integer));
    }
    get totalLead() {
        const leadsArr = this.adSets.map((x) => x.totalLead);
        return (0, utils_1.sum)(leadsArr);
    }
    get totalSearch() {
        const searchArr = this.adSets.map((x) => x.totalSearch);
        return (0, utils_1.sum)(searchArr);
    }
};
exports.Campaign = Campaign;
Campaign.targetClass = titan_ads_1.titanAds.Campaign;
__decorate([
    (0, ShapeDecorators_1.objectProperty)({
        path: titan_ads_1.titanAds.hasAdSets,
        maxCount: 1
    }),
    __metadata("design:type", ShapeSet_1.ShapeSet),
    __metadata("design:paramtypes", [ShapeSet_1.ShapeSet])
], Campaign.prototype, "adSets", null);
__decorate([
    (0, ShapeDecorators_1.objectProperty)({
        path: titan_ads_1.titanAds.fromTemplate,
        shape: Campaign,
        maxCount: 1
    }),
    __metadata("design:type", Campaign),
    __metadata("design:paramtypes", [Campaign])
], Campaign.prototype, "fromTemplate", null);
__decorate([
    (0, ShapeDecorators_1.objectProperty)({
        path: titan_ads_1.titanAds.brandAccount,
        maxCount: 1
    }),
    __metadata("design:type", BrandAccount),
    __metadata("design:paramtypes", [BrandAccount])
], Campaign.prototype, "account", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: titan_ads_1.titanAds.conversionObjective,
        maxCount: 1,
        dataType: xsd_1.xsd.string,
        // required: true,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], Campaign.prototype, "conversionObjective", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: titan_ads_1.titanAds.conversionEvent,
        maxCount: 1
        // required: true,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], Campaign.prototype, "conversionEvent", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: titan_ads_1.titanAds.dailyBudget,
        maxCount: 1,
        // required: false,
    }),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], Campaign.prototype, "dailyBudget", null);
__decorate([
    (0, ShapeDecorators_1.objectProperty)({
        path: titan_ads_1.titanAds.delivering,
        maxCount: 1,
    }),
    __metadata("design:type", Delivering_1.Delivering),
    __metadata("design:paramtypes", [Delivering_1.Delivering])
], Campaign.prototype, "delivering", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: titan_ads_1.titanAds.geo,
        maxCount: 1,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], Campaign.prototype, "geo", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: titan_ads_1.titanAds.isQuickLaunched,
        dataType: xsd_1.xsd.boolean,
        maxCount: 1,
        defaultValue: 'false',
    }),
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [Boolean])
], Campaign.prototype, "isQuickLaunched", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: titan_ads_1.titanAds.isTemplate,
        dataType: xsd_1.xsd.boolean,
        maxCount: 1,
        defaultValue: 'false',
    }),
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [Boolean])
], Campaign.prototype, "isTemplate", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: titan_ads_1.titanAds.lifetimeBudget,
        maxCount: 1,
        // required: false,
    }),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], Campaign.prototype, "lifetimeBudget", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: titan_ads_1.titanAds.offer,
        maxCount: 1,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], Campaign.prototype, "offer", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: titan_ads_1.titanAds.vertical,
        maxCount: 1,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], Campaign.prototype, "vertical", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: titan_ads_1.titanAds.totalClicks,
        maxCount: 1,
        dataType: xsd_1.xsd.integer,
    }),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], Campaign.prototype, "totalClicks", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: titan_ads_1.titanAds.totalImpressions,
        maxCount: 1,
        dataType: xsd_1.xsd.integer,
    }),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], Campaign.prototype, "totalImpressions", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: titan_ads_1.titanAds.totalSpend,
        maxCount: 1,
        dataType: xsd_1.xsd.integer,
    }),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], Campaign.prototype, "totalSpend", null);
exports.Campaign = Campaign = Campaign_1 = __decorate([
    package_1.linkedShape,
    __metadata("design:paramtypes", [Object, Boolean, String])
], Campaign);
let AdSet = AdSet_1 = class AdSet extends LevelInfo {
    /**
     * @param campaignOrNode The campaign to which this adset will belong
     */
    constructor(campaignOrNode, options, template) {
        if (campaignOrNode instanceof Campaign) {
            const { deviceAndBrowser, final, name, placement, topics } = options;
            const prefix = (0, utils_1.generateAdSetPrefix)(deviceAndBrowser, placement);
            const adSetId = AdSet_1.generateNewId(campaignOrNode, prefix);
            const adSetIdentifier = name ? name : `${adSetId}${prefix}`;
            // console.log(adSetName);
            if (!final) {
                super();
            }
            else {
                const URI = campaignOrNode.uri + '/' + adSetIdentifier;
                const adSetNode = models_1.NamedNode.getOrCreate(URI, true);
                adSetNode.overwrite(rdf_1.rdf.type, titan_ads_1.titanAds.AdSet);
                super(adSetNode);
            }
            this.campaign = campaignOrNode;
            this.identifier = adSetIdentifier;
            if (deviceAndBrowser) {
                this.deviceAndBrowser = deviceAndBrowser;
            }
            if (placement) {
                this.placement = placement;
            }
            if (topics) {
                this.topics.addFrom(topics);
            }
        }
        else {
            super(campaignOrNode);
        }
    }
    remove() {
        this.ads.forEach((ad) => ad.remove());
        super.remove();
    }
    get shortName() {
        var _a, _b;
        if (this.identifier && ((_a = this.campaign) === null || _a === void 0 ? void 0 : _a.identifier)) {
            return ((_b = this.campaign) === null || _b === void 0 ? void 0 : _b.identifier) + '-' + this.identifier;
        }
        if (this.name) {
            return this.name.split(/[,\s]/g)[0];
        }
        // console.log('No name or identifier found for adset',this.uri);
        return this.quoraId.toString();
    }
    get isActive() {
        var _a;
        return this.status === 'RUNNING' && ((_a = this.campaign) === null || _a === void 0 ? void 0 : _a.status) === 'RUNNING';
    }
    get dailyRevenue() {
        return this.ads.map(a => a.dailyRevenue || 0).reduce((a, b) => a + b, 0);
    }
    get totalRevenue() {
        return this.ads.map(a => a.totalRevenue || 0).reduce((a, b) => a + b, 0);
    }
    get dailySales() {
        return this.ads.map(a => a.dailySales || 0).reduce((a, b) => a + b, 0);
    }
    get totalSales() {
        return this.ads.map(a => a.totalSales || 0).reduce((a, b) => a + b, 0);
    }
    get spendSinceLastSale() {
        return this.ads.map((a) => a.spendSinceLastSale || 0).reduce((a, b) => a + b, 0);
    }
    calculatePayout() {
        const payouts = this.ads.map(ad => ad.calculatePayout());
        return payouts.reduce((sum, p) => sum + p, 0);
    }
    /**
     *
     * @param name A unique name to give to the template
     * @param campaign An optional pre-existing campaign to clone as a template
     */
    static async createTemplate(name, campaign, brandAccount, adSet) {
        return Server_1.Server.call(this, 'createTemplate', name, campaign, brandAccount, adSet);
    }
    static generateNewId(campaign, prefix, increment = true) {
        const numOfPreviousAdSets = campaign.adSets.filter((a) => a.identifier && a.identifier.slice(3) === prefix).size;
        const newId = (0, utils_1.zeroPad)(increment ? numOfPreviousAdSets + 1 : numOfPreviousAdSets);
        // console.log(numOfPreviousAdSets, newId);
        return newId;
    }
    static loadAll() {
        return Server_1.Server.call(package_1.packageName, 'loadAll', AdSet_1.shape.namedNode);
    }
    static loadAllTemplates() {
        return Server_1.Server.call(this, 'loadAllTemplates').then(({ templates }) => templates);
    }
    /**
     * Updates the bid amount locally and in quora
     * @param newValue
     */
    setBidAmountInQuora(newValue, changeType) {
        // if(!this.fromTemplate && !this.isQuickLaunched && !this.launchDate) {
        //   console.warn(`AdSet ${this.identifier} is not created through the dashboard. Skipping bid amount update`);
        //   return Promise.resolve(false);
        // }
        if (changeType === 'percentage') {
            this.bidAmount = this.bidAmount * (1 + (newValue / 100));
        }
        else {
            this.bidAmount = newValue;
        }
        Observation_2.Observation.createFor(this, titan_ads_1.titanAds.bidAmount, newValue, new Date());
        return this.updateInQuora(`Please click the link and update the bid amount to ${new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            maximumFractionDigits: 2,
            minimumFractionDigits: 2,
        }).format(newValue)}`);
    }
    setDeviceAndBrowser(newValue) {
        //set new device and browser
        this.deviceAndBrowser = newValue;
        //update the adset name
        if (this.launchDate) {
            this.setName();
        }
        //check if any observation for device and browser exists for this adset
        if (Observation_2.Observation.getObservationsOf(this, titan_ads_1.titanAds.deviceAndBrowser).size === 0) {
            //create a new observation with the original value before changing it, so we still know what the original value was
            let originalDate;
            if (this.launchDate) {
                let [month, date, year] = this.launchDate.split('/');
                originalDate = new Date(year.length == 2 ? parseInt('20' + year) : parseInt(year), parseInt(month) - 1, parseInt(date));
            }
            else {
                //else set date to a year ago
                originalDate = new Date();
                originalDate.setYear(originalDate.getYear() - 1);
            }
            Observation_2.Observation.createFor(this, titan_ads_1.titanAds.deviceAndBrowser, newValue, originalDate);
        }
        //create an observation for the new value
        Observation_2.Observation.createFor(this, titan_ads_1.titanAds.deviceAndBrowser, newValue, new Date());
        //update all new properties in quora (name and device and browser), with fallback text
        // return this.updateInQuora(`Please click the link and update the device and browser to ${newValue}. And the name of the ad set to ${this.name}`);
    }
    /**
     * Updates the data in quora with the CURRENT DATA of the ad
     */
    async updateInQuora(changeDescription) {
        if (!this.launchDate) {
            const editLink = `https://www.quora.com/ads/edit_ad_set?id=${this.quoraId}`;
            const logMessage = `Manual update required for Adset <a href="${editLink}">${this.shortName}</a>. <br> Change Description: ${changeDescription}`;
            // Send task email to the client
            this.sendTaskEmail({
                subject: `Manual update of Adset ${this.quoraId} required`,
                message: logMessage,
            });
            console.log(`Could not update adset in quora because it was not launched here. Sent an email for adset ${this.uri} - ${changeDescription}`);
            return;
        }
        return Server_1.Server.call(this, 'updateInQuora');
    }
    async updateFromQuora() {
        return Server_1.Server.call(this, 'updateFromQuora');
    }
    async delete() {
        this.remove();
        return Server_1.Server.call(this, 'delete');
    }
    async quoraCreate() {
        return Server_1.Server.call(this, 'quoraCreate');
    }
    get adDelivery() {
        return this.getValue(titan_ads_1.titanAds.adDelivery);
    }
    set adDelivery(val) {
        this.overwrite(titan_ads_1.titanAds.adDelivery, new models_1.Literal(val));
    }
    get pricingType() {
        const delivery = this.adDelivery;
        switch (delivery) {
            case 'Cost per click':
                return 'cpc';
                break;
            case 'Cost per 1000 impressions':
                return 'cpm';
            case 'Optimise for conversions':
                return 'ocpm';
                break;
            case 'Optimise for video views':
                return 'cpv';
                break;
            case 'Optimise for leads':
                return 'ocpm';
                break;
        }
    }
    // @objectProperty({
    //   path: titanAds.hasAds,
    //   shape: Ad,
    // })
    get ads() {
        return Ad.getSetOf(this.getAllInverse(titan_ads_1.titanAds.adSet));
    }
    get answers() {
        return Answer_1.Answer.getSetOf(this.getAll(titan_ads_1.titanAds.answers));
    }
    get audience() {
        return this.getOneAs(titan_ads_1.titanAds.audience, Audience_1.Audience);
    }
    set audience(val) {
        this.overwrite(titan_ads_1.titanAds.audience, val.node);
    }
    get bidAmount() {
        return this.hasProperty(titan_ads_1.titanAds.bidAmount) ? Number.parseFloat(this.getValue(titan_ads_1.titanAds.bidAmount)) : undefined;
    }
    set bidAmount(val) {
        this.overwrite(titan_ads_1.titanAds.bidAmount, new models_1.Literal(`${val}`));
    }
    // An AdSet MUST belong to a Campaign!
    get campaign() {
        return this.getOneAs(titan_ads_1.titanAds.campaign, Campaign);
    }
    set campaign(val) {
        this.overwrite(titan_ads_1.titanAds.campaign, val.node);
    }
    get fromTemplate() {
        return this.getOneAs(titan_ads_1.titanAds.fromTemplate, AdSet_1);
    }
    set fromTemplate(val) {
        this.overwrite(titan_ads_1.titanAds.fromTemplate, val.node);
    }
    get delivering() {
        return this.getOneAs(titan_ads_1.titanAds.delivering, Delivering_1.Delivering);
    }
    set delivering(val) {
        this.overwrite(titan_ads_1.titanAds.delivering, val.node);
    }
    get deviceAndBrowser() {
        return this.getValue(titan_ads_1.titanAds.deviceAndBrowser);
    }
    set deviceAndBrowser(val) {
        // if (this.name) {
        //   const curPrefix = this.name.slice(3);
        //   const newPrefix = generateAdSetPrefix(val, this.placement);
        //   const newName =
        //     AdSet.generateNewId(this.campaign, newPrefix, curPrefix !== newPrefix) +
        //     newPrefix;
        //   this.name = newName;
        // }
        //
        this.overwrite(titan_ads_1.titanAds.deviceAndBrowser, new models_1.Literal(val));
    }
    get excludedAudiences() {
        return Audience_1.Audience.getSetOf(this.getAll(titan_ads_1.titanAds.excludedAudiences));
    }
    get excludedGeolocations() {
        return Location_1.Location.getSetOf(this.getAll(titan_ads_1.titanAds.excludedGeolocations));
    }
    get targetingTheme() {
        return this.getValue(titan_ads_1.titanAds.targetingTheme);
    }
    set targetingTheme(val) {
        this.overwrite(titan_ads_1.titanAds.targetingTheme, new models_1.Literal(val));
    }
    get excludedKeywords() {
        return this.getAll(titan_ads_1.titanAds.excludedKeywords).getNodeValues();
    }
    set excludedKeywords(words) {
        const curExcludedKeywords = this.getAll(titan_ads_1.titanAds.excludedKeywords);
        curExcludedKeywords.clear();
        const wordNodes = NodeValuesSet_1.NodeValuesSet.fromValues(words);
        curExcludedKeywords.addFrom(wordNodes);
    }
    get excludedLocations() {
        // This is to maintain backwards compatability with the 'Test' brand
        const preexistingLocations = this.getValue(titan_ads_1.titanAds.excludedLocations);
        if (preexistingLocations)
            return preexistingLocations;
        return this.excludedGeolocations.map((loc) => loc.name).join(', ');
    }
    get excludedQuestions() {
        return Question_1.Question.getSetOf(this.getAll(titan_ads_1.titanAds.excludedQuestions));
    }
    get geo() {
        return this.getValue(titan_ads_1.titanAds.geo);
    }
    set geo(val) {
        this.overwrite(titan_ads_1.titanAds.geo, new models_1.Literal(val));
    }
    get geolocations() {
        return Location_1.Location.getSetOf(this.getAll(titan_ads_1.titanAds.geolocations));
    }
    get includedLocations() {
        // This is to maintain backwards compatability with the 'Test' brand
        const preexistingLocations = this.getValue(titan_ads_1.titanAds.includedLocations);
        if (preexistingLocations)
            return preexistingLocations;
        return this.geolocations.map((loc) => loc.name).join(', ');
    }
    // set includedLocations(val:string) {
    //   const locationInstances = Location.getLocalInstances();
    //   const locations = val.split(", ").map(locName => {
    //     return locationInstances.find(l => l.name === locName)?.node;
    //   });
    //   this.moverwrite(titanAds.geolocations,locations);
    // }
    // Should be verified with the targeting type too - this value should only
    // be considered if the targeting type is `Broad`
    get isAutoTargeting() {
        return this.getValue(titan_ads_1.titanAds.isAutoTargeting) === 'true' ? true : false;
    }
    set isAutoTargeting(val) {
        this.overwrite(titan_ads_1.titanAds.isAutoTargeting, new models_1.Literal(`${val}`, xsd_1.xsd.boolean));
    }
    get isQuickLaunched() {
        return this.getValue(titan_ads_1.titanAds.isQuickLaunched) === 'true';
    }
    set isQuickLaunched(val) {
        if (val)
            this.isTemplate = false;
        this.overwrite(titan_ads_1.titanAds.isQuickLaunched, new models_1.Literal(val.toString(), xsd_1.xsd.boolean));
    }
    get isTemplate() {
        return this.getValue(titan_ads_1.titanAds.isTemplate) === 'true';
    }
    set isTemplate(val) {
        // if (val) {
        //   this.campaign?.remove();
        //   this.ads.unsetEach(titanAds.adSet, this.namedNode);
        // } else if (!this.campaign) {
        //   throw new Error('Please assign a campaign to this adset.');
        // }
        this.overwrite(titan_ads_1.titanAds.isTemplate, new models_1.Literal(val.toString(), xsd_1.xsd.boolean));
    }
    get keywords() {
        return this.getAll(titan_ads_1.titanAds.keywords).getNodeValues();
    }
    set keywords(words) {
        const curKeywords = this.getAll(titan_ads_1.titanAds.keywords);
        curKeywords.forEach((keyWord) => {
            curKeywords.delete(keyWord);
        });
        const wordNodes = NodeValuesSet_1.NodeValuesSet.fromValues(words);
        curKeywords.addFrom(wordNodes);
    }
    get offer() {
        return this.getValue(titan_ads_1.titanAds.offer);
    }
    set offer(val) {
        this.overwrite(titan_ads_1.titanAds.offer, new models_1.Literal(val));
    }
    get placement() {
        return this.getValue(titan_ads_1.titanAds.placement);
    }
    set placement(val) {
        // if (this.name) {
        //   const curPrefix = this.name.slice(3);
        //   const newPrefix = generateAdSetPrefix(this.deviceAndBrowser, val);
        //   const newName =
        //     AdSet.generateNewId(this.campaign, newPrefix, curPrefix !== newPrefix) +
        //     newPrefix;
        //   this.name = newName;
        // }
        this.overwrite(titan_ads_1.titanAds.placement, new models_1.Literal(val));
    }
    get questions() {
        return Question_1.Question.getSetOf(this.getAll(titan_ads_1.titanAds.hasQuestions));
    }
    get retargetingWindow() {
        return this.hasProperty(titan_ads_1.titanAds.retargetingWindow) ? Number.parseInt(this.getValue(titan_ads_1.titanAds.retargetingWindow)) : undefined;
    }
    set retargetingWindow(val) {
        this.overwrite(titan_ads_1.titanAds.retargetingWindow, new models_1.Literal(`${val}`, xsd_1.xsd.integer));
    }
    get targetingType() {
        return this.getValue(titan_ads_1.titanAds.targetingType);
    }
    set targetingType(val) {
        this.overwrite(titan_ads_1.titanAds.targetingType, new models_1.Literal(val));
    }
    get targetingDescription() {
        return this.getValue(titan_ads_1.titanAds.targetingDescription);
    }
    set targetingDescription(val) {
        this.overwrite(titan_ads_1.titanAds.targetingDescription, new models_1.Literal(val));
    }
    get targetsFemales() {
        return this.getValue(titan_ads_1.titanAds.targetsFemales) === 'true';
    }
    set targetsFemales(val) {
        this.overwrite(titan_ads_1.titanAds.targetsFemales, new models_1.Literal(`${val}`));
    }
    get targetsMales() {
        return this.getValue(titan_ads_1.titanAds.targetsMales) === 'true';
    }
    set targetsMales(val) {
        this.overwrite(titan_ads_1.titanAds.targetsMales, new models_1.Literal(`${val}`));
    }
    get targetsUnknown() {
        return this.getValue(titan_ads_1.titanAds.targetsUnknown) === 'true';
    }
    set targetsUnknown(val) {
        this.overwrite(titan_ads_1.titanAds.targetsUnknown, new models_1.Literal(`${val}`));
    }
    get topics() {
        return Topic_1.Topic.getSetOf(this.getAll(titan_ads_1.titanAds.hasTopics));
    }
    static generateURI(id) {
        return `${LevelInfo.URI}ad-set/${id}`;
    }
    get totalClicks() {
        return this.hasProperty(titan_ads_1.titanAds.totalClicks) ? Number.parseInt(this.getValue(titan_ads_1.titanAds.totalClicks)) : undefined;
    }
    set totalClicks(val) {
        this.overwrite(titan_ads_1.titanAds.totalClicks, new models_1.Literal(`${val}`, xsd_1.xsd.integer));
    }
    get totalImpressions() {
        return this.hasProperty(titan_ads_1.titanAds.totalImpressions) ? Number.parseInt(this.getValue(titan_ads_1.titanAds.totalImpressions)) : undefined;
    }
    set totalImpressions(val) {
        this.overwrite(titan_ads_1.titanAds.totalImpressions, new models_1.Literal(`${val}`, xsd_1.xsd.integer));
    }
    get optimized() {
        return Boolean_1.Boolean.isTrue(this.getOne(titan_ads_1.titanAds.optimized));
    }
    set optimized(val) {
        this.overwrite(titan_ads_1.titanAds.optimized, Boolean_1.Boolean.toLiteral(val));
    }
    get totalSpend() {
        return this.hasProperty(titan_ads_1.titanAds.totalSpend) ? Number.parseInt(this.getValue(titan_ads_1.titanAds.totalSpend)) : undefined;
    }
    set totalSpend(val) {
        this.overwrite(titan_ads_1.titanAds.totalSpend, new models_1.Literal(`${val}`, xsd_1.xsd.integer));
    }
    setPropertiesFromInput(input) {
        input['adset__AdSet Geo'] && (this.geo = input['adset__AdSet Geo']);
        input['adset__AdSet Offer'] && (this.offer = input['adset__AdSet Offer']);
    }
    getCampaignGroupKey() {
        var _a, _b, _c, _d, _e;
        //adsets are grouped into 1 campaign based on this key
        // the key consists of a combination of campaign and adset properties
        // AdSet[Device+Browser] - AdSet[Placement] - AdSet[Offer] - AdSet[GEO]
        // - Campaign[Vertical] - Campaign[Objective] - Campaign[Conversion Event]
        if (!this.campaign) {
            console.warn(`AdSet ${this.uri} is not connected to a campaign`);
        }
        return (this.deviceAndBrowser +
            '-' +
            this.placement +
            '-' +
            this.offer +
            '-' +
            this.geo +
            '-' +
            ((_a = this.campaign) === null || _a === void 0 ? void 0 : _a.vertical) +
            '-' +
            ((_b = this.campaign) === null || _b === void 0 ? void 0 : _b.conversionObjective) +
            '-' +
            ((_c = this.campaign) === null || _c === void 0 ? void 0 : _c.conversionEvent) +
            '-' +
            ((_d = this.campaign) === null || _d === void 0 ? void 0 : _d.dailyBudget) +
            '-' +
            ((_e = this.campaign) === null || _e === void 0 ? void 0 : _e.lifetimeBudget));
    }
    setName(limit = 255) {
        //Test-C005-003DF
        // KEEP ON (now hardcoded)
        // [Targeting Theme]
        // [Targeting Type]
        // [Targeting Description]
        // [Device+Browser]
        // [Placement]
        // [Offer]
        // [Creation Date - MM/DD/YY]
        const optionalProps = [
            this.targetingTheme,
            this.targetingType,
            this.targetingDescription,
            this.deviceAndBrowser,
            this.placement,
            this.offer,
        ];
        if (!this.identifier) {
            throw new Error('Campaign name and launch date must be set before calling setName()');
        }
        this.name = (0, utils_1.generateName)(this.identifier + ' - UNTESTED', optionalProps, this.launchDate, limit);
        return this.name;
    }
};
exports.AdSet = AdSet;
AdSet.targetClass = titan_ads_1.titanAds.AdSet;
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: titan_ads_1.titanAds.adDelivery,
        maxCount: 1,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], AdSet.prototype, "adDelivery", null);
__decorate([
    (0, ShapeDecorators_1.objectProperty)({
        path: titan_ads_1.titanAds.answers,
        maxCount: 1,
        shape: Answer_1.Answer,
    }),
    __metadata("design:type", ShapeSet_1.ShapeSet),
    __metadata("design:paramtypes", [])
], AdSet.prototype, "answers", null);
__decorate([
    (0, ShapeDecorators_1.objectProperty)({
        path: titan_ads_1.titanAds.audience,
        maxCount: 1,
    }),
    __metadata("design:type", Audience_1.Audience),
    __metadata("design:paramtypes", [Audience_1.Audience])
], AdSet.prototype, "audience", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: titan_ads_1.titanAds.bidAmount,
    }),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], AdSet.prototype, "bidAmount", null);
__decorate([
    (0, ShapeDecorators_1.objectProperty)({
        path: titan_ads_1.titanAds.campaign,
        maxCount: 1,
        required: true,
    }),
    __metadata("design:type", Campaign),
    __metadata("design:paramtypes", [Campaign])
], AdSet.prototype, "campaign", null);
__decorate([
    (0, ShapeDecorators_1.objectProperty)({
        path: titan_ads_1.titanAds.fromTemplate,
        shape: AdSet,
        maxCount: 1
    }),
    __metadata("design:type", AdSet),
    __metadata("design:paramtypes", [AdSet])
], AdSet.prototype, "fromTemplate", null);
__decorate([
    (0, ShapeDecorators_1.objectProperty)({
        path: titan_ads_1.titanAds.delivering,
        maxCount: 1,
    }),
    __metadata("design:type", Delivering_1.Delivering),
    __metadata("design:paramtypes", [Delivering_1.Delivering])
], AdSet.prototype, "delivering", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: titan_ads_1.titanAds.deviceAndBrowser,
        maxCount: 1,
        required: true,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], AdSet.prototype, "deviceAndBrowser", null);
__decorate([
    (0, ShapeDecorators_1.objectProperty)({
        path: titan_ads_1.titanAds.excludedAudiences,
        maxCount: 1,
        shape: Audience_1.Audience,
    }),
    __metadata("design:type", ShapeSet_1.ShapeSet),
    __metadata("design:paramtypes", [])
], AdSet.prototype, "excludedAudiences", null);
__decorate([
    (0, ShapeDecorators_1.objectProperty)({
        path: titan_ads_1.titanAds.excludedGeolocations,
        maxCount: 1,
    }),
    __metadata("design:type", ShapeSet_1.ShapeSet),
    __metadata("design:paramtypes", [])
], AdSet.prototype, "excludedGeolocations", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: titan_ads_1.titanAds.targetingTheme,
        maxCount: 1,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], AdSet.prototype, "targetingTheme", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: titan_ads_1.titanAds.excludedKeywords,
        maxCount: 1,
    }),
    __metadata("design:type", Array),
    __metadata("design:paramtypes", [Array])
], AdSet.prototype, "excludedKeywords", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: titan_ads_1.titanAds.excludedLocations,
        maxCount: 1,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [])
], AdSet.prototype, "excludedLocations", null);
__decorate([
    (0, ShapeDecorators_1.objectProperty)({
        path: titan_ads_1.titanAds.excludedQuestions,
        maxCount: 1,
        shape: Question_1.Question,
    }),
    __metadata("design:type", ShapeSet_1.ShapeSet),
    __metadata("design:paramtypes", [])
], AdSet.prototype, "excludedQuestions", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: titan_ads_1.titanAds.geo,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], AdSet.prototype, "geo", null);
__decorate([
    (0, ShapeDecorators_1.objectProperty)({
        path: titan_ads_1.titanAds.geolocations,
        maxCount: 1,
        shape: Location_1.Location,
    }),
    __metadata("design:type", ShapeSet_1.ShapeSet),
    __metadata("design:paramtypes", [])
], AdSet.prototype, "geolocations", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: titan_ads_1.titanAds.includedLocations,
        maxCount: 1,
        // required: true,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [])
], AdSet.prototype, "includedLocations", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: titan_ads_1.titanAds.isAutoTargeting,
        maxCount: 1,
        dataType: xsd_1.xsd.boolean,
    }),
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [Boolean])
], AdSet.prototype, "isAutoTargeting", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: titan_ads_1.titanAds.isQuickLaunched,
        dataType: xsd_1.xsd.boolean,
        maxCount: 1,
        defaultValue: 'false',
    }),
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [Boolean])
], AdSet.prototype, "isQuickLaunched", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: titan_ads_1.titanAds.isTemplate,
        maxCount: 1,
        dataType: xsd_1.xsd.boolean,
        defaultValue: 'false',
    }),
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [Boolean])
], AdSet.prototype, "isTemplate", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: titan_ads_1.titanAds.keywords,
        maxCount: 1,
    }),
    __metadata("design:type", Array),
    __metadata("design:paramtypes", [Array])
], AdSet.prototype, "keywords", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: titan_ads_1.titanAds.offer,
        maxCount: 1,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], AdSet.prototype, "offer", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: titan_ads_1.titanAds.placement,
        maxCount: 1,
        required: true,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], AdSet.prototype, "placement", null);
__decorate([
    (0, ShapeDecorators_1.objectProperty)({
        path: titan_ads_1.titanAds.hasQuestions,
        maxCount: 1,
        shape: Question_1.Question,
    }),
    __metadata("design:type", ShapeSet_1.ShapeSet),
    __metadata("design:paramtypes", [])
], AdSet.prototype, "questions", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: titan_ads_1.titanAds.retargetingWindow,
        maxCount: 1,
        dataType: xsd_1.xsd.integer,
    }),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], AdSet.prototype, "retargetingWindow", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: titan_ads_1.titanAds.targetingType,
        maxCount: 1,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], AdSet.prototype, "targetingType", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: titan_ads_1.titanAds.targetingDescription,
        maxCount: 1,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], AdSet.prototype, "targetingDescription", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: titan_ads_1.titanAds.targetsFemales,
        maxCount: 1,
        // required: true,
    }),
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [Boolean])
], AdSet.prototype, "targetsFemales", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: titan_ads_1.titanAds.targetsMales,
        maxCount: 1,
        // required: true,
    }),
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [Boolean])
], AdSet.prototype, "targetsMales", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: titan_ads_1.titanAds.targetsUnknown,
        maxCount: 1,
        // required: true,
    }),
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [Boolean])
], AdSet.prototype, "targetsUnknown", null);
__decorate([
    (0, ShapeDecorators_1.objectProperty)({
        path: titan_ads_1.titanAds.hasTopics,
        maxCount: 1,
        shape: Topic_1.Topic,
    }),
    __metadata("design:type", ShapeSet_1.ShapeSet),
    __metadata("design:paramtypes", [])
], AdSet.prototype, "topics", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: titan_ads_1.titanAds.totalClicks,
        maxCount: 1,
        dataType: xsd_1.xsd.integer,
    }),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], AdSet.prototype, "totalClicks", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: titan_ads_1.titanAds.totalImpressions,
        maxCount: 1,
        dataType: xsd_1.xsd.integer,
    }),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], AdSet.prototype, "totalImpressions", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: titan_ads_1.titanAds.optimized,
        maxCount: 1,
        dataType: xsd_1.xsd.boolean,
    }),
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [Boolean])
], AdSet.prototype, "optimized", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: titan_ads_1.titanAds.totalSpend,
        maxCount: 1,
        dataType: xsd_1.xsd.integer,
    }),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], AdSet.prototype, "totalSpend", null);
exports.AdSet = AdSet = AdSet_1 = __decorate([
    package_1.linkedShape,
    __metadata("design:paramtypes", [Object, Object, AdSet])
], AdSet);
let Ad = Ad_1 = class Ad extends LevelInfo {
    static loadAll() {
        return Server_1.Server.call(package_1.packageName, 'loadAll', Ad_1.shape.namedNode);
    }
    static fetchById(adId) {
        return Server_1.Server.call(package_1.packageName, 'loadAdById', adId);
    }
    calculatePayout() {
        if (this.dailySales) {
            return this.dailyRevenue / this.dailySales;
        }
        else {
            // Default hardcoded payout if no sale yet today
            return 110;
        }
    }
    /**
     * Updates the data in quora with the CURRENT DATA of the ad
     */
    async updateInQuora(changeDescription) {
        if (!this.launchDate) {
            const editLink = `https://www.quora.com/ads/edit_ad?id=${this.quoraId}`;
            const logMessage = `Manual update required for Ad <a href="${editLink}">${this.shortName}</a>. <br> Change Description: ${changeDescription}`;
            // Send task email to the client
            this.sendTaskEmail({
                subject: `Manual update of Ad ${this.quoraId} required`,
                message: logMessage,
            });
            return;
        }
        return Server_1.Server.call(this, 'updateInQuora');
    }
    async updateFromQuora() {
        return Server_1.Server.call(this, 'updateFromQuora');
    }
    async quoraCreate() {
        return Server_1.Server.call(this, 'quoraCreate');
    }
    /**
     * Updates the bid amount locally and in quora
     * @param newValue
     * @returns
     */
    setBidAmountInQuora(newValue, changeType) {
        var _a;
        return (_a = this.adSet) === null || _a === void 0 ? void 0 : _a.setBidAmountInQuora(newValue, changeType);
    }
    setDeviceAndBrowser(newValue) {
        var _a;
        return (_a = this.adSet) === null || _a === void 0 ? void 0 : _a.setDeviceAndBrowser(newValue);
    }
    setSpendLimit() {
        return this.turnOff();
    }
    async optimisationTurnOffNotProfitable() {
        await this.turnOff();
        this.statusGuidance = 'KEEP OFF (Not Profitable)';
        this.generateAdName('quora', 255);
        return await this.updateInQuora();
    }
    async optimisationTurnOffRevival() {
        await this.turnOff();
        this.statusGuidance = 'KEEP OFF (Better Ad in Ad Set/Revival)';
        this.generateAdName('quora', 255);
        return await this.updateInQuora();
    }
    async optimisationTurnOnRevival() {
        await this.turnOn();
        this.statusGuidance = 'KEEP ON (Revival)';
        this.generateAdName('quora', 255);
        return await this.updateInQuora();
    }
    launchTopPerformingCreative() {
        const adset = this.adSet;
        const viewLink = `${process.env.SITE_ROOT}/view/adset-management/details?uri=${adset.uri}`;
        const logMessage = `Launch top performing creative in the following ad sets: <a href="${viewLink}">${adset.shortName}</a>`;
        this.sendTaskEmail({
            subject: `Launch Top Performing Creative in ${adset.shortName}`,
            message: logMessage
        });
    }
    launchNewAds() {
        const adset = this.adSet;
        const viewLink = `${process.env.SITE_ROOT}/view/adset-management/details?uri=${adset.uri}`;
        const logMessage = `Launch new ads in the following ad sets: <a href="${viewLink}">${adset.shortName}</a>`;
        this.sendTaskEmail({
            subject: `Launch new ads in ${adset.shortName}`,
            message: logMessage
        });
    }
    constructor(adSet, lookupValues = []) {
        if (adSet instanceof AdSet) {
            let id;
            do {
                id = generateID();
                if (!lookupValues.includes(id)) {
                    lookupValues.push(id);
                    break;
                }
            } while (true);
            const timestamp = Date.now().toString().slice(1);
            const wholeID = `${timestamp}${id}`;
            const uri = adSet.uri + '/' + wholeID;
            const adNode = models_1.NamedNode.getOrCreate(uri, true);
            adNode.overwrite(rdf_1.rdf.type, titan_ads_1.titanAds.Ad);
            super(adNode);
            this.identifier = wholeID;
            this.adSet = adSet;
            this.statusGuidance = 'UNTESTED';
        }
        else {
            super(adSet);
        }
    }
    get shortName() {
        var _a, _b, _c;
        if (this.identifier) {
            return ((_b = (_a = this.adSet) === null || _a === void 0 ? void 0 : _a.campaign) === null || _b === void 0 ? void 0 : _b.identifier) + '-' + ((_c = this.adSet) === null || _c === void 0 ? void 0 : _c.identifier) + '-' + this.identifier;
        }
        if (this.name) {
            return this.name.split(/[,\s]/g)[0];
        }
        // console.log('No name or identifier found for ad',this.uri);
        return this.quoraId.toString();
    }
    get isActive() {
        var _a, _b, _c;
        return this.status === 'RUNNING' && ((_a = this.adSet) === null || _a === void 0 ? void 0 : _a.status) === 'RUNNING' && ((_c = (_b = this.adSet) === null || _b === void 0 ? void 0 : _b.campaign) === null || _c === void 0 ? void 0 : _c.status) === 'RUNNING';
    }
    get ctaAsEnum() {
        if (!this.cta) {
            console.warn(`No CTA has been set for this ad (${this.id})`);
            return null;
        }
        return this.cta.toLowerCase().replace(/ /g, '_');
    }
    // An Ad MUST belong to an adset!
    get adSet() {
        return this.getOneAs(titan_ads_1.titanAds.adSet, AdSet);
    }
    set adSet(val) {
        this.overwrite(titan_ads_1.titanAds.adSet, val.node);
    }
    get spendSinceLastSale() {
        return this.hasProperty(titan_ads_1.titanAds.spendSinceLastSale) ? (parseFloat(parseFloat(this.getValue(titan_ads_1.titanAds.spendSinceLastSale)).toFixed(2)) || 0) : undefined;
    }
    set spendSinceLastSale(val) {
        this.overwrite(titan_ads_1.titanAds.spendSinceLastSale, new models_1.Literal(`${val}`, xsd_1.xsd.integer));
    }
    get dailyRevenue() {
        return this.hasProperty(titan_ads_1.titanAds.dailyRevenue) ? (Number.parseInt(this.getValue(titan_ads_1.titanAds.dailyRevenue)) || 0) : undefined;
    }
    set dailyRevenue(val) {
        this.overwrite(titan_ads_1.titanAds.dailyRevenue, new models_1.Literal(`${val}`, xsd_1.xsd.decimal));
    }
    get totalRevenue() {
        return this.hasProperty(titan_ads_1.titanAds.totalRevenue) ? Number.parseInt(this.getValue(titan_ads_1.titanAds.totalRevenue)) : undefined;
    }
    set totalRevenue(val) {
        this.overwrite(titan_ads_1.titanAds.totalRevenue, new models_1.Literal(`${val}`, xsd_1.xsd.decimal));
    }
    get advertiser() {
        return this.getValue(titan_ads_1.titanAds.advertiser);
    }
    set advertiser(val) {
        this.overwrite(titan_ads_1.titanAds.advertiser, new models_1.Literal(val));
    }
    get assetFile() {
        return this.getValue(titan_ads_1.titanAds.assetFile);
    }
    set assetFile(val) {
        this.overwrite(titan_ads_1.titanAds.assetFile, new models_1.Literal(val));
    }
    get bodyText() {
        return this.getValue(titan_ads_1.titanAds.bodyText);
    }
    set bodyText(val) {
        this.overwrite(titan_ads_1.titanAds.bodyText, new models_1.Literal(val));
    }
    get brandLogo() {
        return this.hasProperty(titan_ads_1.titanAds.brandLogo) ? +this.getValue(titan_ads_1.titanAds.brandLogo) : undefined;
    }
    set brandLogo(val) {
        this.overwrite(titan_ads_1.titanAds.brandLogo, new models_1.Literal(`${val}`));
    }
    get headlineDescription() {
        return this.getValue(titan_ads_1.titanAds.headlineDescription);
    }
    set headlineDescription(val) {
        this.overwrite(titan_ads_1.titanAds.headlineDescription, new models_1.Literal(val));
    }
    get subHeadlineDescription() {
        return this.getValue(titan_ads_1.titanAds.subHeadlineDescription);
    }
    set subHeadlineDescription(val) {
        this.overwrite(titan_ads_1.titanAds.subHeadlineDescription, new models_1.Literal(val));
    }
    get businessName() {
        return this.getValue(titan_ads_1.titanAds.businessName);
    }
    set businessName(val) {
        this.overwrite(titan_ads_1.titanAds.businessName, new models_1.Literal(val));
    }
    get copyDescription() {
        return this.getValue(titan_ads_1.titanAds.copyDescription);
    }
    set copyDescription(val) {
        this.overwrite(titan_ads_1.titanAds.copyDescription, new models_1.Literal(val));
    }
    get creativeType() {
        return this.getValue(titan_ads_1.titanAds.creativeType);
    }
    set creativeType(val) {
        this.overwrite(titan_ads_1.titanAds.creativeType, new models_1.Literal(val));
    }
    get image() {
        return this.getOneAs(titan_ads_1.titanAds.image, ImageObject_1.ImageObject);
    }
    set image(val) {
        this.overwrite(titan_ads_1.titanAds.image, val.namedNode);
    }
    get video() {
        return this.getOneAs(titan_ads_1.titanAds.video, VideoObject_1.VideoObject);
    }
    set video(val) {
        this.overwrite(titan_ads_1.titanAds.video, val.namedNode);
    }
    get cta() {
        return this.getValue(titan_ads_1.titanAds.cta);
    }
    set cta(val) {
        this.overwrite(titan_ads_1.titanAds.cta, new models_1.Literal(val));
    }
    get delivering() {
        return this.getOneAs(titan_ads_1.titanAds.delivering, Delivering_1.Delivering);
    }
    set delivering(val) {
        this.overwrite(titan_ads_1.titanAds.delivering, val.node);
    }
    get headline() {
        return this.getValue(titan_ads_1.titanAds.headline);
    }
    set headline(val) {
        this.overwrite(titan_ads_1.titanAds.headline, new models_1.Literal(val));
    }
    get landingPage() {
        return this.getOneAs(titan_ads_1.titanAds.hasLandingPage, LandingPage_1.LandingPage);
    }
    set landingPage(val) {
        this.overwrite(titan_ads_1.titanAds.hasLandingPage, val.namedNode);
    }
    get fullLandingPageUrl() {
        return this.getValue(titan_ads_1.titanAds.hasFullLandingPageUrl);
    }
    set fullLandingPageUrl(val) {
        this.overwrite(titan_ads_1.titanAds.hasFullLandingPageUrl, new models_1.Literal(val));
    }
    get launchDate() {
        return this.getValue(titan_ads_1.titanAds.launchDate);
    }
    set launchDate(val) {
        this.overwrite(titan_ads_1.titanAds.launchDate, new models_1.Literal(val));
    }
    get network() {
        return this.getValue(titan_ads_1.titanAds.network);
    }
    set network(val) {
        this.overwrite(titan_ads_1.titanAds.network, new models_1.Literal(val));
    }
    get platform() {
        return this.getValue(titan_ads_1.titanAds.platform);
    }
    set platform(val) {
        this.overwrite(titan_ads_1.titanAds.platform, new models_1.Literal(val));
    }
    get promotedAnswer() {
        return this.getOneAs(titan_ads_1.titanAds.promotedAnswer, Answer_1.Answer);
    }
    set promotedAnswer(val) {
        this.overwrite(titan_ads_1.titanAds.promotedAnswer, val.node);
    }
    get statusGuidance() {
        return this.getValue(titan_ads_1.titanAds.statusGuidance);
    }
    set statusGuidance(val) {
        this.overwrite(titan_ads_1.titanAds.statusGuidance, new models_1.Literal(val));
    }
    get subVertical() {
        return this.getValue(titan_ads_1.titanAds.subVertical);
    }
    set subVertical(val) {
        this.overwrite(titan_ads_1.titanAds.subVertical, new models_1.Literal(val));
    }
    get trackers() {
        return this.getAll(titan_ads_1.titanAds.trackers).getNodeValues();
    }
    set trackers(newTrackers) {
        const curTrackers = this.getAll(titan_ads_1.titanAds.trackers);
        curTrackers.clear();
        const trackerNodes = NodeValuesSet_1.NodeValuesSet.fromValues(newTrackers);
        curTrackers.addFrom(trackerNodes);
    }
    get utmTemplate() {
        return this.getValue(titan_ads_1.titanAds.utmTemplate);
    }
    set utmTemplate(val) {
        this.overwrite(titan_ads_1.titanAds.utmTemplate, new models_1.Literal(val));
    }
    setLandingPage(masterUrl, landingPageName, adSet) {
        //updated landing page specs: we use the master url and insert the IDS of the campaign, adset and ad
        //https://truth.customtrk.com/5eb580a1-f205-47c6-b391-ba8d1b06dd26?camp=T-C010&AdSet=003MF&Ad=705556662200bP5mhPnS
        // camp=T-C010
        // AdSet=003MF
        // Ad=705556662200bP5mhPnS
        const landingPageUrl = new URL(masterUrl);
        // We're using `searchParams.set()`, as it's an idempotent operation,
        // so we don't need to worry about dealing with '?' or appending new
        // parameters or replacing old ones - using the URL object will deal with
        // these cases
        landingPageUrl.searchParams.set('camp', adSet.campaign.identifier);
        landingPageUrl.searchParams.set('AdSet', adSet.identifier);
        landingPageUrl.searchParams.set('Ad', this.identifier.toString());
        // We're able to clean up the landing page URL before saving it, that is,
        // the "base" landing page URL, the one that'll be used to identify if
        // duplicates exist
        const baseLandingPageUrl = new URL(landingPageUrl);
        baseLandingPageUrl.searchParams.delete('camp');
        baseLandingPageUrl.searchParams.delete('AdSet');
        baseLandingPageUrl.searchParams.delete('Ad');
        // if we don't care about saving any query params, we can just save it as
        // landingPageUrl.href.replace(landingPageUrl.search, ""); - and this will
        // retain any path
        //the masterUrl gets saved with the "landing page Name" into LandingPage objects
        //So lets see if we have a landing page with the same name and master url
        let landingPageShape = LandingPage_1.LandingPage.getLocalInstances().find((l) => {
            return l.url === baseLandingPageUrl.href && l.name === landingPageName;
        });
        //if not we create a new one
        if (!landingPageShape) {
            console.info(`No landing page called ${landingPageName} found... creating new instance`);
            landingPageShape = new LandingPage_1.LandingPage(baseLandingPageUrl.href);
            landingPageShape.name = landingPageName;
            landingPageShape.save();
        }
        //connect the shape
        this.landingPage = landingPageShape;
        //and also save the full URL that we created for this specific ad (this is what we sent to quora)
        this.fullLandingPageUrl = landingPageUrl.href;
    }
    setPropertiesFromInput(input) {
        input['ad__Network'] && (this.network = input['ad__Network']);
        input['ad__Advertiser'] && (this.advertiser = input['ad__Advertiser']);
        input['ad__Sub-Vertical'] && (this.subVertical = input['ad__Sub-Vertical']);
    }
    generateAdName(platform, limit) {
        var _a, _b, _c, _d, _e;
        const optionalProps = [
            this.statusGuidance || 'UNTESTED',
            this.headlineDescription,
            this.subHeadlineDescription,
            this.creativeType == 'Image'
                ? (((_a = this.image) === null || _a === void 0 ? void 0 : _a.name) || '')
                : this.creativeType == 'Video'
                    ? (((_b = this.video) === null || _b === void 0 ? void 0 : _b.name) || '')
                    : this.creativeType,
            this.cta,
            ((_c = this.landingPage) === null || _c === void 0 ? void 0 : _c.name) || '',
            this.businessName,
            ((_d = this.adSet) === null || _d === void 0 ? void 0 : _d.deviceAndBrowser) || '',
            ((_e = this.adSet) === null || _e === void 0 ? void 0 : _e.targetingTheme) || '',
        ];
        if (!this.identifier || !this.launchDate || !this.adSet || !this.adSet.identifier || !this.adSet.campaign || !this.adSet.campaign.identifier) {
            throw new Error('Ad identifier, Adset + identifier, Campaign + identifier and launch date must be set before generating ad name');
        }
        this.name = (0, utils_1.generateName)(this.shortName, optionalProps, this.launchDate, limit);
        return this.name;
    }
    getVariableNameFromName() {
        var _a;
        return (_a = this.name) === null || _a === void 0 ? void 0 : _a.split(",")[0].split(' _ ')[0].split(' - ')[0];
    }
    getVariableNameFromUrl() {
        var _a;
        //as a last resort we can find back the matching ad by looking at the landing page URL of the ad
        //and extracting the campaign, adset and ad from the URL
        //this is likely only needed with custom created ads that were not created by any code we manage
        // example: ?camp=TF&AdSet=7D&Ad=Ad1 turn into TF-7D-Ad1
        const urlParams = new URLSearchParams(((_a = this.fullLandingPageUrl) === null || _a === void 0 ? void 0 : _a.includes('?')) ? this.fullLandingPageUrl.split('?')[1] : '');
        return `${urlParams.get('camp') || urlParams.get('Camp')}-${urlParams.get('AdSet') || urlParams.get('adSet')}-${urlParams.get('Ad') || urlParams.get('ad')}`;
    }
    get totalClicks() {
        return this.hasProperty(titan_ads_1.titanAds.totalClicks) ? Number.parseInt(this.getValue(titan_ads_1.titanAds.totalClicks)) : undefined;
    }
    set totalClicks(val) {
        this.overwrite(titan_ads_1.titanAds.totalClicks, new models_1.Literal(`${val}`, xsd_1.xsd.integer));
    }
    get totalImpressions() {
        return this.hasProperty(titan_ads_1.titanAds.totalImpressions) ? Number.parseInt(this.getValue(titan_ads_1.titanAds.totalImpressions)) : undefined;
    }
    set totalImpressions(val) {
        this.overwrite(titan_ads_1.titanAds.totalImpressions, new models_1.Literal(`${val}`, xsd_1.xsd.integer));
    }
    get totalSpend() {
        return this.hasProperty(titan_ads_1.titanAds.totalSpend) ? Number.parseInt(this.getValue(titan_ads_1.titanAds.totalSpend)) : undefined;
    }
    set totalSpend(val) {
        this.overwrite(titan_ads_1.titanAds.totalSpend, new models_1.Literal(`${val}`, xsd_1.xsd.integer));
    }
    get answer() {
        return this.getValue(titan_ads_1.titanAds.answer);
    }
    set answer(val) {
        this.overwrite(titan_ads_1.titanAds.answer, new models_1.Literal(val));
    }
    get question() {
        return this.getValue(titan_ads_1.titanAds.question);
    }
    set question(val) {
        this.overwrite(titan_ads_1.titanAds.question, new models_1.Literal(val));
    }
};
exports.Ad = Ad;
Ad.targetClass = titan_ads_1.titanAds.Ad;
__decorate([
    (0, ShapeDecorators_1.objectProperty)({
        path: titan_ads_1.titanAds.adSet,
        required: true,
        maxCount: 1,
        shape: AdSet,
    }),
    __metadata("design:type", AdSet),
    __metadata("design:paramtypes", [AdSet])
], Ad.prototype, "adSet", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: titan_ads_1.titanAds.spendSinceLastSale,
        dataType: xsd_1.xsd.integer,
        maxCount: 1,
    })
    // get spendSinceLastSale(): number {
    //   return this.clicksSinceLastSale * this.dailyAveragePayout;
    // }
    ,
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], Ad.prototype, "spendSinceLastSale", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: titan_ads_1.titanAds.dailyRevenue,
        dataType: xsd_1.xsd.decimal,
        required: true,
        maxCount: 1,
    }),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], Ad.prototype, "dailyRevenue", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: titan_ads_1.titanAds.totalRevenue,
        dataType: xsd_1.xsd.decimal,
        required: true,
        maxCount: 1,
    }),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], Ad.prototype, "totalRevenue", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: titan_ads_1.titanAds.advertiser,
        maxCount: 1,
        dataType: xsd_1.xsd.string
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], Ad.prototype, "advertiser", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: titan_ads_1.titanAds.assetFile,
        maxCount: 1,
        dataType: xsd_1.xsd.string
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], Ad.prototype, "assetFile", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: titan_ads_1.titanAds.bodyText,
        maxCount: 1,
        dataType: xsd_1.xsd.string
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], Ad.prototype, "bodyText", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: titan_ads_1.titanAds.brandLogo,
        dataType: xsd_1.xsd.integer,
        maxCount: 1,
    }),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], Ad.prototype, "brandLogo", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: titan_ads_1.titanAds.headlineDescription,
        maxCount: 1,
        dataType: xsd_1.xsd.string
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], Ad.prototype, "headlineDescription", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: titan_ads_1.titanAds.subHeadlineDescription,
        maxCount: 1,
        dataType: xsd_1.xsd.string
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], Ad.prototype, "subHeadlineDescription", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: titan_ads_1.titanAds.businessName,
        maxCount: 1,
        dataType: xsd_1.xsd.string
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], Ad.prototype, "businessName", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: titan_ads_1.titanAds.copyDescription,
        required: true,
        maxCount: 1,
        dataType: xsd_1.xsd.string
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], Ad.prototype, "copyDescription", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: titan_ads_1.titanAds.creativeType,
        maxCount: 1,
        dataType: xsd_1.xsd.string,
        // required: true,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], Ad.prototype, "creativeType", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: titan_ads_1.titanAds.image,
        shape: ImageObject_1.ImageObject,
        maxCount: 1,
    }),
    __metadata("design:type", ImageObject_1.ImageObject),
    __metadata("design:paramtypes", [ImageObject_1.ImageObject])
], Ad.prototype, "image", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: titan_ads_1.titanAds.video,
        shape: VideoObject_1.VideoObject,
        maxCount: 1,
    }),
    __metadata("design:type", VideoObject_1.VideoObject),
    __metadata("design:paramtypes", [VideoObject_1.VideoObject])
], Ad.prototype, "video", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: titan_ads_1.titanAds.cta,
        required: true,
        maxCount: 1,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], Ad.prototype, "cta", null);
__decorate([
    (0, ShapeDecorators_1.objectProperty)({
        path: titan_ads_1.titanAds.delivering,
        maxCount: 1,
        shape: Delivering_1.Delivering
    }),
    __metadata("design:type", Delivering_1.Delivering),
    __metadata("design:paramtypes", [Delivering_1.Delivering])
], Ad.prototype, "delivering", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: titan_ads_1.titanAds.headline,
        maxCount: 1,
        dataType: xsd_1.xsd.string
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], Ad.prototype, "headline", null);
__decorate([
    (0, ShapeDecorators_1.objectProperty)({
        path: titan_ads_1.titanAds.hasLandingPage,
        // No longer required since quicklauncher feature...
        // Promoted answers don't have a landing page associated with them -
        // the answer url IS the landing page
        // required: true,
        maxCount: 1,
        shape: LandingPage_1.LandingPage
    }),
    __metadata("design:type", LandingPage_1.LandingPage),
    __metadata("design:paramtypes", [LandingPage_1.LandingPage])
], Ad.prototype, "landingPage", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: titan_ads_1.titanAds.hasFullLandingPageUrl,
        maxCount: 1,
        dataType: xsd_1.xsd.string
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], Ad.prototype, "fullLandingPageUrl", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: titan_ads_1.titanAds.launchDate,
        required: true,
        maxCount: 1,
        dataType: xsd_1.xsd.string
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], Ad.prototype, "launchDate", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: titan_ads_1.titanAds.network,
        maxCount: 1,
        dataType: xsd_1.xsd.string
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], Ad.prototype, "network", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: titan_ads_1.titanAds.platform,
        required: true,
        maxCount: 1,
        dataType: xsd_1.xsd.string
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], Ad.prototype, "platform", null);
__decorate([
    (0, ShapeDecorators_1.objectProperty)({
        path: titan_ads_1.titanAds.promotedAnswer,
        maxCount: 1,
        shape: Answer_1.Answer
    }),
    __metadata("design:type", Answer_1.Answer),
    __metadata("design:paramtypes", [Answer_1.Answer])
], Ad.prototype, "promotedAnswer", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: titan_ads_1.titanAds.statusGuidance,
        required: false,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], Ad.prototype, "statusGuidance", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: titan_ads_1.titanAds.subVertical,
        maxCount: 1,
        dataType: xsd_1.xsd.string
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], Ad.prototype, "subVertical", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: titan_ads_1.titanAds.trackers,
        // maxCount: 1,
    }),
    __metadata("design:type", Array),
    __metadata("design:paramtypes", [Array])
], Ad.prototype, "trackers", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: titan_ads_1.titanAds.utmTemplate,
        maxCount: 1,
        dataType: xsd_1.xsd.string
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], Ad.prototype, "utmTemplate", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: titan_ads_1.titanAds.totalClicks,
        maxCount: 1,
        dataType: xsd_1.xsd.integer,
    }),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], Ad.prototype, "totalClicks", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: titan_ads_1.titanAds.totalImpressions,
        maxCount: 1,
        dataType: xsd_1.xsd.integer,
    }),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], Ad.prototype, "totalImpressions", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: titan_ads_1.titanAds.totalSpend,
        maxCount: 1,
        dataType: xsd_1.xsd.integer,
    }),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], Ad.prototype, "totalSpend", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: titan_ads_1.titanAds.answer,
        maxCount: 1,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], Ad.prototype, "answer", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: titan_ads_1.titanAds.question,
        maxCount: 1,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], Ad.prototype, "question", null);
exports.Ad = Ad = Ad_1 = __decorate([
    package_1.linkedShape,
    __metadata("design:paramtypes", [Object, Array])
], Ad);
//# sourceMappingURL=TitanShapes.js.map